// extracted by mini-css-extract-plugin
module.exports = {"actionsPopover":"OfficeRequestWaitlist_actionsPopover__3iS2C","actionsDropdownContent":"OfficeRequestWaitlist_actionsDropdownContent__allWj"};